const INDUSTRY_MENU = [
  {
    key: 'healthcare',
    label: 'Healthcare',
    items: [
      { key: 'experience-centers', label: 'Experience Centers', path: '/industries/medical' },
      { key: 'obesity-management', label: 'Obesity Management Clinics / Weight Management Centers', path: '/industries/medical' },
      { key: 'rehabilitation-medicine', label: 'Rehabilitation Medicine', path: '/industries/medical' },
      { key: 'clinical-nutrition', label: 'Clinical Nutrition', path: '/industries/medical' },
      { key: 'orthopedics', label: 'Orthopedics', path: '/industries/medical' },
      { key: 'cardiology', label: 'Cardiology', path: '/industries/medical' },
      { key: 'pediatrics', label: 'Pediatrics', path: '/industries/medical' }
    ]
  },
  {
    key: 'fitness-sports',
    label: 'Fitness & Sports',
    items: [
      { key: 'gyms-fitness-centers', label: 'Gyms & Fitness Centers', path: null },
      { key: 'yoga-studios', label: 'Yoga Studios', path: null },
      { key: 'pilates-studios', label: 'Pilates Studios', path: null }
    ]
  },
  {
    key: 'professional-sports',
    label: 'Professional Sports Teams & Athletic Institutions',
    items: [
      { key: 'physical-fitness-institutions', label: 'Physical Fitness Institutions', path: null },
      { key: 'youth-training-academies', label: 'Youth Training Academies', path: null },
      { key: 'sports-clubs', label: 'Sports Clubs', path: null }
    ]
  }
]

function getIndustryMenuItemType(item = {}) {
  return typeof item.path === 'string' && item.path.startsWith('/') ? 'route' : 'static'
}

function getResponsiveHeaderHeight(viewportWidth) {
  return Number(viewportWidth) <= 700 ? 50 : 64
}

function getAboutNavigationState(path = '') {
  if (path === '/about') {
    return { parentActive: true, activeItem: 'about' }
  }

  return { parentActive: false, activeItem: null }
}

function getRouteScrollPosition(to = {}, headerHeight = 64) {
  if (to.hash) {
    return {
      el: to.hash,
      top: headerHeight,
      behavior: 'smooth'
    }
  }

  return { top: 0 }
}

module.exports = {
  INDUSTRY_MENU,
  getAboutNavigationState,
  getIndustryMenuItemType,
  getResponsiveHeaderHeight,
  getRouteScrollPosition
}
